import { api as apiAxiosInstance } from "../services/api";

const fetchReadmeToken = async () => {
  try {
    const response = await apiAxiosInstance.get("/docs/readme-token");
    const { url } = response.data;
    window.location.href = url;
  } catch (error) {
    console.error("Failed to fetch readme token:", error);
    window.location.href = "/";
  }
};

export default fetchReadmeToken;
